import OmniApiClient from "./base";

export const statisticsApi = {
  // --- Shopping Table Sync (Statistics) ---
  triggerSync: () => OmniApiClient.post("/statistics/populate"),

  getCronStatus: () => OmniApiClient.get("/statistics/cron/status"),

  startCron: (cronExpression = "0 3 * * *") =>
    OmniApiClient.post("/statistics/cron/start", null, {
      params: { cron_expression: cronExpression },
    }),

  stopCron: () => OmniApiClient.post("/statistics/cron/stop"),
};

export const profitStatisticsApi = {
  getCronStatus: () => OmniApiClient.get("/statistics/profit/cron/status"),

  startCron: (cronExpression = "0 8 * * *") =>
    OmniApiClient.post("/statistics/profit/cron/start", null, {
      params: { cron_expression: cronExpression },
    }),

  stopCron: () => OmniApiClient.post("/statistics/profit/cron/stop"),

  storeOrdersForDateRange: (startDate, endDate) =>
    OmniApiClient.post("/plenty/orders/range", null, {
      params: { start_date: startDate, end_date: endDate },
    }),

  storeRetoursForDateRange: (startDate, endDate) =>
    OmniApiClient.post("/plenty/retours/range", null, {
      params: { start_date: startDate, end_date: endDate },
    }),

  syncAmazonOrders: (
    startDate,
    endDate,
    marketplaces,
    { calculateFees = true } = {},
  ) => {
    const params = {
      start_date: startDate,
      end_date: endDate,
      calculate_fees: calculateFees,
    };
    if (marketplaces && marketplaces.length) {
      params.marketplaces = marketplaces.join(",");
    }
    return OmniApiClient.post("/amazon/orders/sync", null, { params });
  },

  syncAmazonReturns: (startDate, endDate, marketplaces) => {
    const params = { start_date: startDate, end_date: endDate };
    if (marketplaces && marketplaces.length) {
      params.marketplaces = marketplaces.join(",");
    }
    return OmniApiClient.post("/amazon/returns/sync", null, { params });
  },
};
